const URL_API = "https://api.ipify.org/?format=json";
fetch(URL_API)
.then(respuestaRaw => respuestaRaw.json())
.then(respuesta => {
  var ipClient= respuesta.ip;
  var URLactual = window.location.toString();
  var url = URLactual.replaceAll('&','/');  
  const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        console.log("Request completed");
      }
    };
  xhttp.open("POST", "https://www.latinflores.com/integration/control_purchased.php", true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhttp.send("URLactual=" + url + "&ipClient=" + ipClient);
});

function InfoHat(params='') {
  const elem = document.getElementById('ProductPopup-dfa4a199-4913-400e-9390-105dfe606c48');
  elem.click();
}

function showFold(params=''){
  const elem = document.getElementById('ProductPopup-84618ee1-a1bf-439f-86c3-a78d937cf65d');
  elem.click();
}

function raisePopupWindow(params=''){
  const elem = document.getElementById('ProductPopup-e574306a-512c-48b4-8b2d-e0dd3f7fe1e4');
  elem.click();
}

function search_custom(e,u){
  var q = document.getElementById("gl-d-searchbox-input").value;
  var keycode = e.keyCode || e.which;  
  if (keycode == 13) {
    window.location.href = 'https://www.gamboafashion.com'+u+'?sort_by=manual&q='+q;
  }
}

function link(p,u){
  if(p == 2) {
     if(u != ''){
        window.location.href = 'https://www.gamboafashion.com'+u;
     }    
  }  
}
function link_home(u){
  if(u != ''){
        window.location.href = 'https://www.gamboafashion.com'+u;
  } 
}

function pipedrive_send(){
  var email = document.getElementById("ContactForm-email").value;
  var name = document.getElementById("ContactForm-name").value;
  var phone = document.getElementById("ContactForm-phone").value;
  var country = document.getElementById("ContactForm-order-country").value;
  var reason = document.getElementById("ContactForm-reason").value;
  var qty = document.getElementById("ContactForm-order-quantity").value;
  var body = document.getElementById("ContactForm-body").value;
  var validEmail =  /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;
  
  if( validEmail.test(email) ){
	const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        console.log("Request completed");
      }
    };
    xhttp.open("POST", "https://lfxx.latinflores.com/apps/pipedrive_send.php", true);
    xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.send("email=" + email + "&name=" + name + "&phone=" + phone + "&country=" + country + "&reason=" + reason + "&qty=" + qty + "&body=" + body);  
  }
}

function mnu_show(){
  document.getElementById('bar_mnu').style.display = 'block';
}

function mnu_hide(){
  document.getElementById('bar_mnu').style.display = 'none';
}

 document.getElementById("Subscribe").onclick = function() {
  var email = document.getElementById("NewsletterForm--footer").value;
    var validEmail =  /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;
  
  if( validEmail.test(email) ){
	const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        console.log("Request completed");
      }
    };
    xhttp.open("POST", "https://lfxx.latinflores.com/apps/datos_mailerlite_gamboa.php", true);
    xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.send("email=" + email);  
  }
 };
